import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import icon2 from '../../images/icon/m_01.svg'

import icon9 from '../../images/icon/m_08.svg'

import icon11 from '../../images/icon/m_10.svg'
import icon12 from '../../images/icon/m_11.svg'
import icon13 from '../../images/icon/sms-white-icon01.svg'
import logo from '../../images/logo/m.png'



import MobileMenu from '../MobileMenu/MobileMenu'

const Header = (props) => {

    const [mobailActive, setMobailState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80) {
                setSticky(true);
            } else {
                setSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Clean up
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);


    const SubmitHandler = (e) => {
        e.preventDefault()
    }

    return (

        <div id="xb-header-area" className="header-area header-style-two header-transparent">

            <div className={`xb-header stricky  ${isSticky ? 'stricked-menu stricky-fixed' : ''}`}>
                <div className="container">
                    <div className="header__wrap ul_li_between">
                        <div className="header-logo">
                            <Link onClick={ClickHandler} to="/"><img src={logo} alt="" /></Link>
                        </div>
                        <div className="main-menu__wrap ul_li navbar navbar-expand-xl">
                            <nav className="main-menu collapse navbar-collapse">
                                <ul>
                                    <li className="menu-item-has-children">
                                        <Link onClick={ClickHandler} to="/"><span>Home</span></Link>

                                    </li>
                                    <li className="menu-item-has-children megamenu">
                                        <Link onClick={ClickHandler} to="/"><span>company</span></Link>
                                        <ul className="submenu">
                                            <li>
                                                <div className="mega_menu_wrapper">
                                                    <div className="container">
                                                        <div className="mega_menu_wrapper_inner">
                                                            <div className="row">
                                                                <div className="col-xl-9">
                                                                    <div className="megamenu_pages_wrapper mb-5">
                                                                        <div className="row g-10">
                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="/about">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon2} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">About
                                                                                            Us</small>
                                                                                    </span>
                                                                                    <span className="description mb-0">
                                                                                        Learn more about Uniflame
                                                                                    </span>
                                                                                </Link>
                                                                            </div>



                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="/terms-conditions">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon11} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">Terms
                                                                                            & Conditions</small>
                                                                                    </span>
                                                                                    <span className="description mb-0">Your
                                                                                        Rights and
                                                                                        Responsibilities.</span>
                                                                                </Link>
                                                                            </div>
                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="/privacy-policy">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon12} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">Privacy
                                                                                            Policy</small>
                                                                                    </span>
                                                                                    <span
                                                                                        className="description mb-0">Commitment
                                                                                        to Confidentiality.</span>
                                                                                </Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <ul
                                                                        className="btns_group p-0 unordered_list justify-content-start">
                                                                        <li>
                                                                            <Link onClick={ClickHandler} to="/contact"
                                                                                className="thm-btn thm-btn--aso megamenu-btn thm-btn--header-black">Get
                                                                                free consultation</Link>
                                                                        </li>


                                                                    </ul>
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>


                                    <li className="menu-item-has-children">
                                        <Link onClick={ClickHandler} to="/casestudy"><span>Casestudy</span></Link>

                                    </li>


                                    {/* service start  */}


                                    <li className="menu-item-has-children megamenu">
                                        <Link onClick={ClickHandler} to="/service"><span>Service</span></Link>
                                        <ul className="submenu">
                                            <li>
                                                <div className="mega_menu_wrapper">
                                                    <div className="container">
                                                        <div className="mega_menu_wrapper_inner">
                                                            <div className="row">
                                                                <div className="col-xl-9">
                                                                    <div className="megamenu_pages_wrapper mb-5">
                                                                        <div className="row g-10">
                                                                                <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="/service">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon12} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">Services
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>
                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon2} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">Shopify
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>
                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon9} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">Magento
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>

                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon11} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">Odoo Implementation
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>
                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon12} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">PIM
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>

                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon12} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">Akeneo
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>
                                                                            {/* servive nav */}
                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon12} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">React Native
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>





                                                                            </div>






                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon12} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">Flutter
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>



                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon12} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">React Web Apps
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>

                                                                            <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon12} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">Data Analytics
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>
  <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon12} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">SAP
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>


  <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon12} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">Headless Website
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>
                                                                              <div className="col-xl-4 col-md-4">
                                                                                <Link onClick={ClickHandler} className="iconbox_block_2"
                                                                                    to="">
                                                                                    <span className="icon_title_wrap">
                                                                                        <small className="iconbox_icon">
                                                                                            <img src={icon12} alt="" />
                                                                                        </small>
                                                                                        <small
                                                                                            className="iconbox_title">Cloud Infrastructure
                                                                                        </small>
                                                                                    </span>

                                                                                </Link>
                                                                            </div>







                                                                        </div>
                                                                    </div>



                                                                    <ul
                                                                        className="btns_group p-0 unordered_list justify-content-start">
                                                                        <li>
                                                                            <Link onClick={ClickHandler} to="/contact"
                                                                                className="thm-btn thm-btn--aso megamenu-btn thm-btn--header-black">Get
                                                                                free consultation</Link>
                                                                        </li>


                                                                    </ul>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </li>

                                    <li><Link onClick={ClickHandler} to="/contact"><span>Contact</span></Link></li>
                                </ul>
                            </nav>
                            <div className="xb-header-wrap">
                                <div className={`xb-header-menu ${mobailActive ? "active" : ""}`}>
                                    <div className="xb-header-menu-scroll lenis lenis-smooth">
                                        <div className="xb-menu-close xb-hide-xl xb-close" onClick={() => setMobailState(!mobailActive)}></div>
                                        <div className="xb-logo-mobile xb-hide-xl">
                                            <Link onClick={ClickHandler} to="/" rel="home"><img src={logo}
                                                alt="" /></Link>
                                        </div>
                                        <div className="xb-header-mobile-search xb-hide-xl">
                                            <form role="search" onSubmit={SubmitHandler}>
                                                <input type="text" placeholder="Search..." name="s"
                                                    className="search-field" />
                                                <button className="search-submit" type="submit"><i
                                                    className="far fa-search"></i></button>
                                            </form>
                                        </div>
                                        <nav className="xb-header-nav">
                                            <MobileMenu />
                                        </nav>
                                    </div>
                                </div>
                                <div className="xb-header-menu-backdrop"></div>
                            </div>
                        </div>
                        <div className="header-bar-mobile side-menu d-xl-none">
                            <button className="xb-nav-mobile" onClick={() => setMobailState(!mobailActive)}>
                                <i className="far fa-bars"></i>
                            </button>
                        </div>
                        <div className="header-contact d-none d-md-block">
                            <Link onClick={ClickHandler} to="/contact" className="thm-btn thm-btn--aso thm-btn--header-black">Let’s talk
                                <img src={icon13} alt="" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Header;